export const prependUserToSelectNote = (note: string, fullName: string) => {
  return `${fullName} added this note: ${note}`;
};
